import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { SharedModelComponent } from '../components/shared-model/shared-model.component';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { SnackBarComponent } from '../components/snackBar/snack-bar/snack-bar.component';
import * as CryptoJS from 'crypto-js';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class UtilsService implements OnDestroy {
  public _routerSub = Subscription.EMPTY;
  environment: any = environment;
  sub: Subscription = new Subscription()
  screenSizeObj = {
    type: '',
    width: 0,
    height: 0
  };
  selectedCategory: any = {
    guidId: '',
    activeFeatureIconFile: '',
    featureAltTag: '',
    inActiveFeatureIconFile: '',
    category: '',
    categoryType: ''
  };
  tokenExpirationTime = 30 * 58;
  formFieldsData: any;
  inputVal = new BehaviorSubject('')
  showLoader: boolean;
  selectedSubCategory: any = []
  subCatOpenIndex = -1;
  profileSideActiveIndex = -1;
  pageStack: object = {}
  pinCodeLength = 6;
  otpLength = 1;
  // regex for all
  noSpaceRegex = /^\S*$/;
  alphabateRegex = /^[a-zA-Z , ]+$/i;
  phoneRegex = /^[1-9]{1}[0-9]{9}$/;
  otpRegex = /^[a-zA-Z\-0-9]{4}$/;
  numberRegex = /^[0-9]+$/;
  amountRegex = /^[0-9\.]+$/;
  alphaNumericRegex = /^[a-zA-Z0-9]*$/;
  emailRegex = /^(([^<>()[\]\\.,;:!#$%&*\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/;
  nameRegex = /^[a-zA-Z](([ ][a-zA-Z])?[a-zA-Z]*)*$/;
  numRegex = /^[0-9]$/;
  guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  addressRegex = /^[a-zA-Z0-9](([ ][a-zA-Z0-9-_,' /])?[a-zA-Z0-9-_,' /]*)*$/;
  gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  websiteRegex = /^(https?:\/\/[a-zA-Z0-9_\-]+(?:\.[a-zA-Z0-9_\-]+)*\.[a-zA-Z]{2,4}(?:\/[a-zA-Z0-9_]+)*(?:\/[a-zA-Z0-9_]+\.[a-zA-Z]{2,4}(?:\?[a-zA-Z0-9_]+\=[a-zA-Z0-9_]+)?)?(?:\&[a-zA-Z0-9_]+\=[a-zA-Z0-9_]+)*)$/;
  apiUrl = environment.apiUrl;
  baseApiUrl = environment.apiUrl;
  baseUrl = environment.baseUrl;
  blobUrl = environment.blobUrl;
  webUrlForDistributor = environment.webUrlForDistributor;
  skipInterceptorHeaders = new HttpHeaders().set('InterceptorSkipHeader', 'true');
  addTempTokenHeader = new HttpHeaders().set('addTempTokenHeader', 'true');

  profileSideBarData = [{
    icon: '/assets/images/saved-items/order.svg',
    title: 'Orders',
    link: '/your-orders'
  },
  {
    icon: '/assets/images/saved-items/saved-items.svg',
    title: 'Saved Items',
    link: '/saved-items'
  },
  {
    icon: '/assets/images/saved-items/address-book.svg',
    title: 'Address book',
    link: '/address-book'
  },
  {
    icon: '/assets/images/saved-items/review.svg',
    title: 'My Reviews',
    link: '/my-reviews'
  },
  {
    icon: '/assets/images/saved-items/profile.svg',
    title: 'My Profile',
    link: '/profile'
  }, {
    icon: '/assets/images/saved-items/profile.svg',
    title: 'Change Password',
    link: '/change-password'
  },]
  utils: any;

  customOptionsForBanner: OwlOptions = {
    loop: false,
    autoplay: true,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 0,
    center: true,
    margin: 0,
    responsive: {
      0: {
        items: 1
      }
    },
  };

  customOptionsForSmallBanner: OwlOptions = {
    loop: false,
    autoplay: true,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 0,
    center: true,
    margin: 0,
    responsive: {
      0: {
        items: 1
      }
    },
  };
  optionForBannerArea: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 0,
    margin: 32,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      }
    },
  };
  customOptionsForVideo: OwlOptions = {
    loop: true,
    autoplay: false,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 0,
    center: true,
    margin: 0,
    lazyLoad: true,
    lazyLoadEager: 1,
    responsive: {
      0: {
        items: 1
      }
    },
  };

  menuList = new BehaviorSubject([]);
  eshopCatList = new BehaviorSubject([]);
  customerCareInfo: any;
  filterSelected: any = [];
  filterData: any = [];
  filterQueryObj!: { queryObj: any; apiObjArr: any; };
  skipAuthorization!: boolean;

  //guest user values for session
  emailForGuestUser: any;
  addressForGuestUser!: any[];
  tmpTokenForGuestUser: any;
  isAddressSame!: boolean;
  isBackToLastPage: boolean = false;
  orderPlaceData: any;
  isRecentLogin: boolean = false;
  discountCouponData = new BehaviorSubject({});
  paginationData: Subject<string> = new BehaviorSubject('');
  userPinCode: any = '';
  showForceUpdate = new BehaviorSubject(false);
  showHeaderFooter = new BehaviorSubject(false);
  focusedControl: any;
  WhatsAppPromotionalConsent: boolean = true;
  isCheckedLimit: boolean = false;
  subscribedEmail: any;

  webBannerList: any;
  mobBannerList: any;
  constructor(private _matSnackBar: MatSnackBar, private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialog: MatDialog, @Inject(DOCUMENT) private document: Document) {
    this.showLoader = false;
  }

  setProductCategoryName(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('productInfo', JSON.stringify(data));
    }
  }

  getProductInfo(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('productInfo');
    } else {
      return ''
    }
  }

  getUserPicode() {
    if (isPlatformBrowser(this.platformId)) {
      return this.getItemFromLocalStorage('userPincode') && this.getItemFromLocalStorage('userPincode') != 'null' ? this.getItemFromLocalStorage('userPincode') : '';
    } else {
      return ''
    }
  }

  getUser() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('userGuidId') && localStorage.getItem('userGuidId') != 'null' ? localStorage.getItem('userGuidId') : '';
    } else {
      return ''
    }
  }

  setUserPicode(pincode: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.userPinCode = pincode;
      return this.setItemToLocalStorage('userPincode', pincode ? pincode : '')
    }
  }

  setGuestUserToken(token: any) {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.setItem('tempUserToken', token ? token : '')
    }
  }

  removeTempToken() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.removeItem('tempUserToken');
    }
  }

  getTmpUserToken() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('tempUserToken') && localStorage.getItem('tempUserToken') != 'null' ? localStorage.getItem('tempUserToken') : '';
    } else {
      return
    }
  }

  removeUserPincode() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.removeItem('userPincode');
    }
  }

  setDoRefresh() {
    // let tabId: any = this.getTabID();
    // localStorage.setItem('tabRefreshOccurs', tabId)
    // return localStorage.setItem('doRefresh', 'true')
  }

  getDoRefresh() {
    // return localStorage.getItem('doRefresh');
  }

  removeDoRefresh() {
    // localStorage.removeItem('tabRefreshOccurs');
    // return localStorage.removeItem('doRefresh')
  }

  getTabID() {
    return sessionStorage.getItem('tabId');
  }

  setTabID() {
    return sessionStorage.setItem('tabId', this.getRandomUUID());
  }

  removeTabID() {
    return sessionStorage.removeItem('tabId');
  }

  showLoading() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.document.body.classList.add("stop-scrolling");
        this.showLoader = true;
      }, 1);
    }
  }
  hideLoading() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.showLoader = false;
        this.document.body.classList.remove("stop-scrolling");
      }, 500);
    }
  }
  regexCompare(value: any, regex: any) {
    return regex.test(String(value).toLowerCase());
  }

  openSnackBar(message: string, className: string, action?: string) {
    const config = {
      duration: 2000,
      panelClass: ['custom-snackbar', className], // Add 'custom-snackbar' class
    };
    this._matSnackBar.open(message, action, config);
  }



  openSnackBarHtml(data: any, className: any) {
    this._matSnackBar.openFromComponent(SnackBarComponent, {
      data: {
        html: data
      },
      duration: 5000,
      panelClass: className
    });
  }

  getRandomUUID() {
    return String(Math.round(Math.random() * 1000000000000000));
  }

  encryptData(msg: any) {
    let key = CryptoJS.enc.Utf8.parse(environment.encryptSecretKey);
    let iv = CryptoJS.enc.Utf8.parse(environment.ivKey);

    let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(msg), key, {
      keySize: 128 / 8,
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    let result = encrypted.toString();
    return result;
  }

  decryptText(textToDecrypt: any) {
    let key = CryptoJS.enc.Utf8.parse(environment.encryptSecretKey);
    let iv = CryptoJS.enc.Utf8.parse(environment.ivKey);
    let bytes = CryptoJS.AES.decrypt(textToDecrypt, key, {
      keySize: 128 / 8,
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  encryptarrayData(data: any): any | null {
    if (data === null) {
      return null; // Skip encryption for null
    }

    try {
      const jsonData = JSON.stringify(data);
      const key = CryptoJS.enc.Utf8.parse(environment.encryptSecretKey);
      const iv = CryptoJS.enc.Utf8.parse(environment.ivKey);

      const encrypted = CryptoJS.AES.encrypt(jsonData, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
      });

      return encrypted.toString(); // Base64 string
    } catch (err) {
      console.error('Encryption failed:', err);
      return '';
    }
  }

  decryptarrayText(encryptedText: any | null): any {
    if (encryptedText === null) {
      return null; // Skip decryption for null
    }

    try {
      const key = CryptoJS.enc.Utf8.parse(environment.encryptSecretKey);
      const iv = CryptoJS.enc.Utf8.parse(environment.ivKey);

      const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
      });

      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8).trim();

      try {
        return JSON.parse(decryptedText);
      } catch {
        return decryptedText;
      }
    } catch (err) {
      console.error('Decryption failed:', err);
      return null;
    }
  }
  getFormControlName(label: any) {
    let labelName = label.split(" ").map((element: any) => {
      return element ? element.toLowerCase() : '';
    }).join('_');

    return labelName.split(",").map((element: any) => {
      return element ? element.toLowerCase() : '';
    }).join('_');
  }

  processError(err: any) {
    if (isPlatformBrowser(this.platformId)) {

      let message: string;
      if (err.error instanceof HttpErrorResponse) {
        message = err.error.message ? err.error.message : "Error Event";
      }
      else {
        if (err.error.StatusCode == 401) {
          this.utils.clearAuthData();
          this.utils.router.navigate(['sign-in'])
        }
        else {
          if (err.error && err.error.message) {
            this.utils.openSnackBar(err.error.message, 'error-toster');
            message = `Error Code: ${err.status}\nMessage:${err.error.message}`;
          }
          else if (err.error && err.error.Message) {
            this.utils.openSnackBar(err.error.Message, 'error-toster');
            message = `Error Code: ${err.status}\nMessage:${err.error.Message}`;
          }
          else {
            this.utils.openSnackBar('something went wrong !!', 'error-toster');
            message = `Error Code: ${err.status}\nMessage:something went wrong !!`;
          }
        }
      }
      this.utils.hideLoading();
      if (err.error.StatusCode == 401) { this.utils.clearAuthData(); this.utils.router.navigate(['sign-in']) }
      return throwError(() => {
        return err.status
      })
    } else {
      return ''
    }
  }

  decryptJwt(text: any) {
    const helper = new JwtHelperService();
    return helper.decodeToken(text);
  }

  decryptUrlAndGetObj(urlParams: any) {
    let urlToDecode = Object.keys(urlParams)
    const decoded = this.decryptJwt(urlToDecode[0]);
    let pars = decoded.text;
    let paramsArray = pars.split('&');
    let tempObj: any = {};
    paramsArray.forEach((element: any) => {
      let elementArr = element.split('=')
      tempObj[elementArr[0].toLowerCase()] = elementArr[1]
    });
    return tempObj;
  }

  getActiveRouter(url: any) {
    let urlArr = url.split('/');
    return urlArr[1].toLowerCase();
  }

  getActiveRouterWhileParams(url: any) {
    let urlArr = url.split('?');
    return urlArr[0].toLowerCase();
  }

  getGuidFromParams(data: any) {
    let tmp = data.split('?');
    let guidArr = tmp[tmp.length - 1].split('=');
    return guidArr[guidArr.length - 1];
  }
  checkValidityOfGuid(guid: any) {
    return this.guidRegex.exec(guid) && guid != '00000000-0000-0000-0000-000000000000' ? true : false;
    // return true;
  }

  getToken() {
    if (isPlatformBrowser(this.platformId)) {
      let token = localStorage.getItem('token');
      return token;
    } else {
      return ''
    }
  }
  getUserGuid() {
    if (isPlatformBrowser(this.platformId)) {
      let userGuid = localStorage.getItem('userGuidId');
      return userGuid;
    } else {
      return ' '
    }
  }
  getPhoneNumber(phoneNo: any) {
    let tmpNumArray = phoneNo.split('-');
    return tmpNumArray[tmpNumArray.length - 1]
  }

  backToRoot() {
    this.router.navigate(['/']);
  }

  setAddresses(addresses: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('selectedAddresses', JSON.stringify(addresses))
    }
  }
  getAddresses() {
    if (isPlatformBrowser(this.platformId)) {
      let data: any = localStorage.getItem('selectedAddresses')
      return JSON.parse(data)
    }
  }

  validURL(str: any) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  changeTextToUppercase(value: any) {
    return value.toUpperCase();
  }

  convertHTMLtoString(text: string) {
    if (isPlatformBrowser(this.platformId)) {
      const body = text;
      const temp = document.createElement("div");
      temp.innerHTML = body;
      return (temp.textContent || temp.innerText);
    } else {
      return ''
    }
  }

  openCartChangeDialog(callback?: any) {
    this.dialog.open(SharedModelComponent, {
      disableClose: true,
      panelClass: 'cookiesModel',
      data: {
        title: 'Cart Updated',
        content: 'Few items/price have been changed/updated, please review the cart before moving forward.',
        closeBtnText: "Close",
        isCartChange: true
      }
    });
  }

  getBase64FromFile(fileToUpload: any) {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      let base64;
      fileReader.onload = function (fileLoadedEvent: any) {
        base64 = fileLoadedEvent.target.result;
        base64 = base64.replace(/^[^,]*,/, '');
        resolve(base64);
      };
      fileReader.onerror = reject;
      fileReader.readAsDataURL(fileToUpload);
    });
  }

  getCommaSeparatedValue(data: any, key: string) {
    return [...new Set(Array.prototype.map.call(data, function (item) { return item[key]; }))].join(",")
  }

  getOrderStatus(orderStatus: any) {
    switch (orderStatus.toLowerCase()) {
      case 'pending':
      case 'pending payment': {
        return 'Payment Pending';
      }
      //payment
      case 'failed': {
        return 'Payment Failed';
      }
      case 'declined': {
        return 'Payment Declined';
      }
      case 'rejected': {
        return 'Payment Rejected';
      }
      case 'success': {
        return 'Payment Success'
      }
      //order
      case 'orderpending': {
        return 'Pending';
      }
      case 'orderunshipped': {
        return 'Unshipped';
      }
      case 'ordershipped': {
        return 'Shipped';
      }
      case 'orderconfirmed': {
        return 'Confirmed'
      }
      case 'orderdelivered':
      case 'ordercompleted':
      case 'complete': {
        return 'Delivered'
      }
      case 'ordercancelledapproved':
      case 'ordercancelled':
      case 'canceled':
      case 'cancelled': { //for transaction
        return 'Cancelled';
      }
      case 'refunded': {
        return 'Refunded'
      }
      case 'suspected fraud': {
        return 'Suspected Fraud';
      }
      case 'test order': {
        return 'Test Order';
      }
      default: {
        return '';
      }
    }
  }

  isElementVisible(elementId: string): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.getElementById(elementId);
      if (!element) {
        return false;
      }
      const rect = element.getBoundingClientRect();
      // return rect.top >= 0 && rect.bottom <= window.innerHeight;
      const windowHeight = window.innerHeight;
      return rect.bottom > 0 && rect.top < windowHeight;
    } else {
      return false; // Not in the browser platform
    }
  }
  clearAuthData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('expiration')
      localStorage.removeItem('name');
      localStorage.removeItem('userId');
      localStorage.removeItem('userGuidId');
      localStorage.removeItem('pinCode');
      localStorage.removeItem('buyNow');
      localStorage.removeItem('cart')
      localStorage.removeItem('pageCount');
      // let openPageCount: any = this.utils.getItemFromLocalStorage('lms_tab')
      // if (openPageCount > 1) {
      //   this.utils.setDoRefresh();
      // }
    }
  }

  createNameForUrl(name: any) {
    let nameAfterSpcicalChar = name?.replace(/[^a-zA-Z0-9& ]/g, '').toLowerCase();
    let nameAfterSpaces = nameAfterSpcicalChar?.split(' ').join('-');
    let nameAfterFourDash = nameAfterSpaces?.replaceAll('----', '-');
    let nameAfterThreeDash = nameAfterFourDash?.replaceAll('---', '-');
    let nameAfterTwoDash = nameAfterThreeDash?.replaceAll('--', '-');
    let nameAfterTwoDashquestion = nameAfterTwoDash?.replaceAll('?', '-');
    name = nameAfterTwoDashquestion?.replace('&', 'and');
    return name && name.length ? name : '';
  }

  removeDashFromUrl(name: any) {
    let nameAfterFourDash = name.replaceAll('-', ' ');
    name = nameAfterFourDash.replace('and', '&');
    return name && name.length ? name : '';
  }

  checkIndexMessage(page: any, totalCount: any, tableSize: any) {
    if (page == 1) {
      return (
        '1-' +
        (totalCount > tableSize ? tableSize : totalCount) +
        ' of ' +
        totalCount
      );
    } else {
      let startingIndex = (page - 1) * tableSize + 1;
      let lastIndex =
        totalCount - tableSize * (page - 1) > tableSize
          ? page * tableSize
          : totalCount;
      return startingIndex + '-' + lastIndex + ' of ' + totalCount;
    }
  }

  openConfirmationPopup(dataForPopUp: any, callBack: any) {
    const dialogRef = this.dialog.open(SharedModelComponent, {
      panelClass: 'cookiesModel',
      // width: '50%',
      disableClose: true,
      data: dataForPopUp
    });
    this.sub.add(dialogRef.afterClosed().subscribe((res) => {
      callBack(res);
    }));
  }

  onFocus(label: any, flag: boolean) {
    flag ? this.focusedControl = label : this.focusedControl = '';
  }

  checkValidation(controlName: any, formName: FormGroup) {
    return (formName.controls[controlName].errors && formName.controls[controlName].touched);
  }

  checkValidationMessage(formName: any, controlName: any, label: any, controlfor?: any) {
    if (formName.controls[controlName].errors) {
      if (formName.controls[controlName].errors['required']) {
        return label + ' is required';
      }
      if (formName.controls[controlName].errors.min) {
        return label + ' should be more than or equals to: ' + formName.controls[controlName].errors.min.min;
      }
      if (formName.controls[controlName].errors.max) {
        return label + ' should not be more than: ' + formName.controls[controlName].errors.max.max;
      }
      if (formName.controls[controlName].errors.minlength) {
        return label + ' minimum allowed length should be: ' + formName.controls[controlName].errors.minlength.requiredLength;
      }
      else if (formName.controls[controlName].errors.maxlength) {
        return label + ' maximum allowed length is: ' + formName.controls[controlName].errors.maxlength.requiredLength;
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'space') {
        return label + ' is not valid!! remove spaces from front (if any).';
      }
      else if (formName.controls[controlName].errors['maliciousInput']) {
        return 'Invalid input detected in ' + label.toLowerCase() + '. Please remove unsafe characters.';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'name') {
        return label + ' is not valid!! remove unwanted spaces or Characters (if any).';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'discountName') {
        return label + ' is not valid!! remove unwanted spaces from front & end (if any).';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'percentage') {
        return label + ' is not valid!! Only two decimals allowed after decimal';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'gstIn') {
        return label + ' is not valid!!';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'domain') {
        return label + ' is not valid!!';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'alphanumericCode') {
        return label + ' is not valid!!';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'address') {
        return label + " is not valid!! Only number ' , - _ and spaces are allowed,remove any space at first place (if any).";
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'password') {
        return label + ' is not valid!! must contain At least one upper case, number and special character';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'email') {
        return label + ' is not valid!! remove unwanted spaces (if any).';
      }
      else if (formName.controls[controlName].errors.pattern && controlfor == 'price') {
        return label + ' is not valid!! remove unwanted spaces, or characters (if any).';
      }
      else if (formName.controls[controlName].errors.ConfirmValidator) {
        return 'Password and Confirm Password didn' + 't match.';
      }
      else if (formName.controls[controlName].errors.email) {
        return 'Enter a valid Email Address';
      }
      else if (formName.controls[controlName].errors.invalidAutocompleteObject) {
        return 'Please enter from the list';
      }
      else if (formName.controls[controlName].errors.alreadySelectedList) {
        return 'Attribute already added';
      } else if (formName.controls[controlName].errors.pattern && controlfor == 'Companywebsite') {
        return label + ' is not valid!! Please enter a valid website URL.';
      }
      else if (formName.controls[controlName].value && !/^[a-zA-Z]*$/.test(formName.controls[controlName].value)) {
        return label + ' should contain Only alphabets.';
      }
      else {
        return '';
      }
    }
    else {
      return '';
    }
  }


  setItemToLocalStorage(itemName: any, item: any) {
    if (isPlatformBrowser(this.platformId)) {
      let itemToSave = this.encryptData(item);
      localStorage.setItem(itemName, itemToSave);
    }
  }

  getItemFromLocalStorage(itemName: any) {
    if (isPlatformBrowser(this.platformId)) {
      let item: any = localStorage.getItem(itemName);
      return item ? this.decryptText(item) : '';
    } else {
      return ''
    }
  }

  reloadPage() {
    location.reload();
  }

  sha512(str: string) {
    return CryptoJS.SHA512(str).toString(CryptoJS.enc.Hex);
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.sub.unsubscribe()
  }
}
